<template>
  <el-button size="small" type="primary" @click="onClickExecuteDailyCheck">일일점검 수행</el-button>
</template>

<script>
import netdeviceConfigInfoAPI from '@/api/config/netdevice/netdevice-info';
import MsgUtil from '@/utils/message';
import { getBasicNotificationData } from '@/utils/hambuger-popup';

export default {
  name: 'WDailyCheckButton',
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    /**
     * [onClickExecuteDailyCheck 일일점검 수행]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExecuteDailyCheck() {
      const target = '일일 점검';
      const action = '수행';
      this.$confirm(...MsgUtil.getCustomConfirmData(`${target}을 ${action}하시겠습니까?`))
        .then(() => {
          netdeviceConfigInfoAPI
            .excuteNetdeviceCheck({
              objId: this.obj.objId,
            })
            .then((result) => {
              if (result.data.success === true) {
                const data = getBasicNotificationData(this.obj, target, true);
                this.$notify(data);
              } else {
                this.$message(MsgUtil.getResultMsgData(action, target, false));
              }
            }).catch((e) => {
              this.$message(MsgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/button/netdevice/DailyCheckButton.vue